exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/column-chart/column-chart.component.scss
// module id = ../../../../../src/app/shared/components/graphs/column-chart/column-chart.component.scss
// module chunks = main